export default class ViewModel {
  constructor({
    data,
    i18n,
    deps,
  }) {
    this.data = data;
    this.i18n = i18n;
    this.deps = deps;
  }
}
